// ============================================================
// THE PEOPLE BEHIND THE STORIES — editable profile data
// ------------------------------------------------------------
// To add a person: drop a portrait into /frontend/public/people/
// (tall stage cut-out on black, ~180x890px) and append an entry.
// All text has { en, te } variants. Set portrait: null to show a
// monogram tile until a photo is available.
// relationshipType: "host" | "interview" | "featured" | "collaborator"
// Only list a relatedStory that genuinely exists on the channel.
// ============================================================
import { SITE } from "@/data/content";

const story = (id, title) => ({
  title,
  url: `https://www.youtube.com/watch?v=${id}`,
  image: `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`,
  imageFallback: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
});

export const PEOPLE = [
  {
    id: "vijayasai-reddy",
    displayOrder: 1,
    featured: true,
    portrait: "/people/vijayasai-reddy.jpg",
    name: { en: "V. Vijayasai Reddy", te: "వి. విజయసాయి రెడ్డి" },
    profession: { en: "Former Rajya Sabha MP, YSRCP", te: "మాజీ రాజ్యసభ సభ్యుడు, వైఎస్సార్‌సీపీ" },
    biography: {
      en: "Chartered accountant turned politician, Vijayasai Reddy served as a Rajya Sabha member and national general secretary of the YSR Congress Party, and was one of Y.S. Jagan Mohan Reddy's closest aides. He resigned from the Rajya Sabha in 2025 and announced his retirement from active politics.",
      te: "చార్టర్డ్ అకౌంటెంట్ నుంచి రాజకీయ నాయకుడిగా మారిన విజయసాయి రెడ్డి వైఎస్సార్ కాంగ్రెస్ పార్టీ రాజ్యసభ సభ్యుడిగా, జాతీయ ప్రధాన కార్యదర్శిగా పనిచేశారు. వై.ఎస్. జగన్ మోహన్ రెడ్డికి అత్యంత సన్నిహితులలో ఒకరు. 2025లో రాజ్యసభకు రాజీనామా చేసి క్రియాశీల రాజకీయాల నుంచి విరమణ ప్రకటించారు.",
    },
    relationshipType: "interview",
    connection: {
      en: "Sat down with Jaffar for a candid interview on politics and friendship.",
      te: "రాజకీయాలు, స్నేహం గురించి జాఫర్‌తో నిర్మొహమాటమైన ఇంటర్వ్యూ.",
    },
    relatedStory: story("TXU3r3CHjNM", "పవన్ నా దోస్తు... రాజకీయం వేరు - స్నేహం వేరు | Interview With Vijayasai Reddy"),
    socialLinks: { x: "https://x.com/VSReddy_MP" },
  },
  {
    id: "sujana-chowdary",
    displayOrder: 2,
    featured: true,
    portrait: "/people/sujana-chowdary.jpg",
    name: { en: "Y. S. Chowdary (Sujana Chowdary)", te: "వై. ఎస్. చౌదరి (సుజనా చౌదరి)" },
    profession: { en: "Industrialist & Former Union Minister of State", te: "పారిశ్రామికవేత్త & మాజీ కేంద్ర సహాయ మంత్రి" },
    biography: {
      en: "Founder of the Sujana Group of industries, Sujana Chowdary served as Union Minister of State for Science & Technology and Earth Sciences (2014–2018) and as a Rajya Sabha member from Andhra Pradesh. He later moved from the TDP to the BJP.",
      te: "సుజనా గ్రూప్ పరిశ్రమల వ్యవస్థాపకుడైన సుజనా చౌదరి కేంద్ర సైన్స్ & టెక్నాలజీ, భూ విజ్ఞాన శాఖల సహాయ మంత్రిగా (2014–2018), ఆంధ్రప్రదేశ్ నుంచి రాజ్యసభ సభ్యుడిగా పనిచేశారు. తరువాత టీడీపీ నుంచి బీజేపీలో చేరారు.",
    },
    relationshipType: "featured",
    connection: {
      en: "Featured on Itlu Mee Jaffar. The specific conversation link will be added soon.",
      te: "ఇట్లు మీ జాఫర్‌లో ప్రత్యేకంగా చోటు. సంభాషణ లింక్ త్వరలో జోడించబడుతుంది.",
    },
    relatedStory: { title: "Itlu Mee Jaffar on YouTube", url: SITE.youtube, image: null },
    socialLinks: { x: "https://x.com/ysujana" },
  },
  {
    id: "sajjala-ramakrishna-reddy",
    displayOrder: 3,
    featured: true,
    portrait: "/people/sajjala-ramakrishna-reddy.jpg",
    name: { en: "Sajjala Ramakrishna Reddy", te: "సజ్జల రామకృష్ణా రెడ్డి" },
    profession: { en: "YSRCP General Secretary & Former Govt. Advisor", te: "వైఎస్సార్‌సీపీ ప్రధాన కార్యదర్శి & మాజీ ప్రభుత్వ సలహాదారు" },
    biography: {
      en: "A former journalist and editor, Sajjala Ramakrishna Reddy is the general secretary of the YSR Congress Party and served as Advisor (Public Affairs) to the Government of Andhra Pradesh from 2019 to 2024.",
      te: "మాజీ జర్నలిస్ట్, సంపాదకుడైన సజ్జల రామకృష్ణా రెడ్డి వైఎస్సార్ కాంగ్రెస్ పార్టీ ప్రధాన కార్యదర్శి. 2019 నుంచి 2024 వరకు ఆంధ్రప్రదేశ్ ప్రభుత్వ ప్రజా వ్యవహారాల సలహాదారుగా పనిచేశారు.",
    },
    relationshipType: "interview",
    connection: {
      en: "Exclusive interview with Jaffar on the YS Sharmila episode and party politics.",
      te: "వైఎస్ షర్మిల వ్యవహారం, పార్టీ రాజకీయాలపై జాఫర్‌తో ప్రత్యేక ఇంటర్వ్యూ.",
    },
    relatedStory: story("1YBe-PrTXTk", "షర్మిల చిట్టా ఇదే! Exclusive Interview With Sajjala Ramakrishna Reddy"),
    socialLinks: {},
  },
  {
    id: "k-kavitha",
    displayOrder: 4,
    featured: true,
    portrait: "/people/k-kavitha.jpg",
    name: { en: "K. Kavitha", te: "కె. కవిత" },
    profession: { en: "Politician & Founder, Telangana Jagruthi", te: "రాజకీయ నాయకురాలు & తెలంగాణ జాగృతి వ్యవస్థాపకురాలు" },
    biography: {
      en: "Daughter of former Telangana Chief Minister K. Chandrashekar Rao, Kavitha represented Nizamabad in the Lok Sabha (2014–2019) and served as a Member of the Telangana Legislative Council. She founded the cultural organisation Telangana Jagruthi.",
      te: "తెలంగాణ మాజీ ముఖ్యమంత్రి కె. చంద్రశేఖర్ రావు కుమార్తె అయిన కవిత నిజామాబాద్ లోక్‌సభ సభ్యురాలిగా (2014–2019), తెలంగాణ శాసన మండలి సభ్యురాలిగా పనిచేశారు. తెలంగాణ జాగృతి సాంస్కృతిక సంస్థను స్థాపించారు.",
    },
    relationshipType: "interview",
    connection: {
      en: "An exclusive podcast conversation with Jaffar on family, KCR and Telangana politics.",
      te: "కుటుంబం, కేసీఆర్, తెలంగాణ రాజకీయాలపై జాఫర్‌తో ప్రత్యేక పాడ్‌కాస్ట్ సంభాషణ.",
    },
    relatedStory: story("Bmel0TXy9Xg", "KCR vs Kavitha మధ్యలో ఒక అమ్మా… | Exclusive Podcast with Kavitha"),
    socialLinks: { x: "https://x.com/RaoKavitha" },
  },
  {
    id: "nara-lokesh",
    displayOrder: 5,
    featured: true,
    portrait: "/people/nara-lokesh.jpg",
    name: { en: "Nara Lokesh", te: "నారా లోకేశ్" },
    profession: { en: "Minister for HRD, IT & Electronics, Andhra Pradesh", te: "ఆంధ్రప్రదేశ్ విద్య, ఐటీ & ఎలక్ట్రానిక్స్ శాఖ మంత్రి" },
    biography: {
      en: "Nara Lokesh is a Telugu Desam Party general secretary and the Mangalagiri MLA, serving as Andhra Pradesh's Minister for Human Resources Development, IT and Electronics since 2024. A Stanford MBA, he is the son of Chief Minister N. Chandrababu Naidu.",
      te: "తెలుగుదేశం పార్టీ ప్రధాన కార్యదర్శి, మంగళగిరి ఎమ్మెల్యే అయిన నారా లోకేశ్ 2024 నుంచి ఆంధ్రప్రదేశ్ విద్య, ఐటీ & ఎలక్ట్రానిక్స్ శాఖ మంత్రిగా ఉన్నారు. స్టాన్‌ఫోర్డ్ ఎంబీఏ అయిన ఆయన ముఖ్యమంత్రి ఎన్. చంద్రబాబు నాయుడు కుమారుడు.",
    },
    relationshipType: "interview",
    connection: {
      en: "Exclusive election-season interview with Jaffar: 'Who is the next CM?'",
      te: "ఎన్నికల వేళ జాఫర్‌తో ప్రత్యేక ఇంటర్వ్యూ: 'తదుపరి సీఎం ఎవరు?'",
    },
    relatedStory: story("RI2Y2A7JiTY", "Exclusive Interview With Nara Lokesh | AP Election | Who Is Next CM?"),
    socialLinks: { x: "https://x.com/naralokesh" },
  },
  {
    id: "jaffar",
    displayOrder: 6,
    featured: true,
    portrait: "/people/jaffar.jpg",
    name: { en: "Jaffar", te: "జాఫర్" },
    profession: { en: "Journalist & Host, Itlu Mee Jaffar", te: "జర్నలిస్ట్ & హోస్ట్, ఇట్లు మీ జాఫర్" },
    biography: {
      en: "A seasoned journalist known for fearless storytelling, Jaffar has worked across television, digital platforms and field reporting, and gained national recognition as a Bigg Boss Telugu Season 3 contestant. Through Itlu Mee Jaffar he delivers investigative stories, social experiments and real-life narratives.",
      te: "నిర్భయ కథనానికి పేరుగాంచిన అనుభవజ్ఞుడైన జర్నలిస్ట్ జాఫర్ టెలివిజన్, డిజిటల్ వేదికలు, క్షేత్ర రిపోర్టింగ్‌లో పనిచేశారు. బిగ్ బాస్ తెలుగు సీజన్ 3 కంటెస్టెంట్‌గా జాతీయ గుర్తింపు పొందారు. ఇట్లు మీ జాఫర్ ద్వారా పరిశోధనాత్మక కథలు, సామాజిక ప్రయోగాలు అందిస్తున్నారు.",
    },
    relationshipType: "host",
    connection: {
      en: "The journalist behind every conversation on this page.",
      te: "ఈ పేజీలోని ప్రతి సంభాషణ వెనుక ఉన్న జర్నలిస్ట్.",
    },
    relatedStory: { title: "Itlu Mee Jaffar on YouTube", url: SITE.youtube, image: null },
    socialLinks: { instagram: SITE.instagram, facebook: SITE.facebook, youtube: SITE.youtube },
  },
  {
    id: "venkaiah-naidu",
    displayOrder: 7,
    featured: true,
    portrait: "/people/venkaiah-naidu.jpg",
    name: { en: "M. Venkaiah Naidu", te: "ఎం. వెంకయ్య నాయుడు" },
    profession: { en: "13th Vice President of India (2017–2022)", te: "భారత 13వ ఉపరాష్ట్రపతి (2017–2022)" },
    biography: {
      en: "Venkaiah Naidu served as the 13th Vice President of India and Chairman of the Rajya Sabha. A former national president of the BJP, he held Union portfolios including Urban Development, Information & Broadcasting and Rural Development.",
      te: "వెంకయ్య నాయుడు భారత 13వ ఉపరాష్ట్రపతిగా, రాజ్యసభ ఛైర్మన్‌గా పనిచేశారు. బీజేపీ మాజీ జాతీయ అధ్యక్షుడైన ఆయన పట్టణాభివృద్ధి, సమాచార & ప్రసార, గ్రామీణాభివృద్ధి వంటి కేంద్ర శాఖలను నిర్వహించారు.",
    },
    relationshipType: "interview",
    connection: {
      en: "An exclusive long-form interview with Jaffar.",
      te: "జాఫర్‌తో సుదీర్ఘ ప్రత్యేక ఇంటర్వ్యూ.",
    },
    relatedStory: story("4H6ASJUXerw", "Exclusive Interview with Dr. M. Venkaiah Naidu Garu"),
    socialLinks: { x: "https://x.com/MVenkaiahNaidu" },
  },
  {
    id: "mohan-babu",
    displayOrder: 8,
    featured: true,
    portrait: "/people/mohan-babu.jpg",
    name: { en: "Mohan Babu", te: "మోహన్ బాబు" },
    profession: { en: "Actor, Producer & Educationist", te: "నటుడు, నిర్మాత & విద్యావేత్త" },
    biography: {
      en: "A Padma Shri awardee, Mohan Babu has acted in and produced hundreds of Telugu films across five decades. He is the founder of the Sree Vidyanikethan Educational Institutions and served as a Rajya Sabha member from 1995 to 2001.",
      te: "పద్మశ్రీ గ్రహీత మోహన్ బాబు ఐదు దశాబ్దాలుగా వందలాది తెలుగు చిత్రాల్లో నటించి, నిర్మించారు. శ్రీ విద్యానికేతన్ విద్యాసంస్థల వ్యవస్థాపకుడైన ఆయన 1995 నుంచి 2001 వరకు రాజ్యసభ సభ్యుడిగా పనిచేశారు.",
    },
    relationshipType: "interview",
    connection: {
      en: "Spoke to Jaffar about the Manchu family dispute.",
      te: "మంచు కుటుంబ వివాదంపై జాఫర్‌తో మాట్లాడారు.",
    },
    relatedStory: story("k3L-3tuBTGk", "Mohan Babu Reacts To The Manchu Brothers Issue"),
    socialLinks: { x: "https://x.com/themohanbabu" },
  },
  {
    id: "cm-ramesh",
    displayOrder: 9,
    featured: true,
    portrait: "/people/cm-ramesh.jpg",
    name: { en: "C. M. Ramesh", te: "సి. ఎం. రమేశ్" },
    profession: { en: "Member of Parliament, Anakapalli (BJP)", te: "లోక్‌సభ సభ్యుడు, అనకాపల్లి (బీజేపీ)" },
    biography: {
      en: "An industrialist and politician, C. M. Ramesh was elected to the Lok Sabha from Anakapalli in 2024. He previously served two terms in the Rajya Sabha, first with the TDP and later with the BJP.",
      te: "పారిశ్రామికవేత్త, రాజకీయ నాయకుడైన సి. ఎం. రమేశ్ 2024లో అనకాపల్లి నుంచి లోక్‌సభకు ఎన్నికయ్యారు. అంతకుముందు టీడీపీ, తరువాత బీజేపీ తరఫున రెండు పర్యాయాలు రాజ్యసభ సభ్యుడిగా పనిచేశారు.",
    },
    relationshipType: "interview",
    connection: {
      en: "Exclusive interview with Jaffar during the 2024 Andhra Pradesh election campaign.",
      te: "2024 ఆంధ్రప్రదేశ్ ఎన్నికల ప్రచారంలో జాఫర్‌తో ప్రత్యేక ఇంటర్వ్యూ.",
    },
    relatedStory: story("mFhXYHw_RoE", "RRR అంటే ఇష్టమే కానీ! Exclusive Interview with BJP MP candidate CM Ramesh"),
    socialLinks: {},
  },
  {
    id: "kiran-kumar-jain",
    displayOrder: 10,
    featured: true,
    portrait: "/people/kiran-kumar-jain.jpg",
    name: { en: "M. Kiran Kumar Jain", te: "ఎం. కిరణ్ కుమార్ జైన్" },
    profession: { en: "Founder & Managing Director, Lalithaa Jewellery", te: "వ్యవస్థాపకుడు & మేనేజింగ్ డైరెక్టర్, లలితా జ్యువెలరీ" },
    biography: {
      en: "Kiran Kumar Jain built Lalithaa Jewellery from a single Chennai store into one of South India's largest jewellery retail chains, known for its low making-charge model and his hands-on, self-made entrepreneurial journey.",
      te: "కిరణ్ కుమార్ జైన్ చెన్నైలో ఒక్క దుకాణంతో మొదలుపెట్టి లలితా జ్యువెలరీని దక్షిణ భారతదేశంలోని అతిపెద్ద ఆభరణాల రిటైల్ చైన్‌లలో ఒకటిగా నిర్మించారు. తక్కువ మేకింగ్ ఛార్జీల విధానం, స్వయంకృషితో ఎదిగిన ప్రయాణం ఆయన ప్రత్యేకత.",
    },
    relationshipType: "interview",
    connection: {
      en: "Exclusive interview with Jaffar on his journey. Lalithaa Jewellery is also a brand partner of Itlu Mee Jaffar.",
      te: "తన ప్రయాణంపై జాఫర్‌తో ప్రత్యేక ఇంటర్వ్యూ. లలితా జ్యువెలరీ ఇట్లు మీ జాఫర్ బ్రాండ్ భాగస్వామి కూడా.",
    },
    relatedStory: story("TF8pbB_ctmY", "ప్రతి ఒక్కరు వినాల్సిన మాటలు! Lalitha Jewellery Kiran | Exclusive Interview"),
    socialLinks: {},
  },
  {
    id: "ram-gopal-varma",
    displayOrder: 11,
    featured: true,
    portrait: "/people/ram-gopal-varma.jpg",
    name: { en: "Ram Gopal Varma", te: "రామ్ గోపాల్ వర్మ" },
    profession: { en: "Film Director, Screenwriter & Producer", te: "సినీ దర్శకుడు, రచయిత & నిర్మాత" },
    biography: {
      en: "Ram Gopal Varma is one of Indian cinema's most influential directors, known for Shiva, Rangeela, Satya, Company and Sarkar. He helped define the modern Indian gangster film and remains an outspoken public voice.",
      te: "శివ, రంగీలా, సత్య, కంపెనీ, సర్కార్ వంటి చిత్రాలతో భారతీయ సినిమాపై బలమైన ముద్ర వేసిన దర్శకుల్లో రామ్ గోపాల్ వర్మ ఒకరు. ఆధునిక భారతీయ గ్యాంగ్‌స్టర్ సినిమాకు రూపునిచ్చిన ఆయన నిర్మొహమాటమైన అభిప్రాయాలకు పేరుగాంచారు.",
    },
    relationshipType: "interview",
    connection: {
      en: "An exclusive, unfiltered interview with Jaffar.",
      te: "జాఫర్‌తో ప్రత్యేక, నిర్మొహమాటమైన ఇంటర్వ్యూ.",
    },
    relatedStory: story("Yu-2Ohy9iZI", "Ram Gopal Varma's Exclusive Interview"),
    socialLinks: { x: "https://x.com/RGVzoomin" },
  },
].sort((a, b) => a.displayOrder - b.displayOrder);
